module.exports = __webpack_public_path__ + "static/media/ck.13ec029e.svg";